import { FC } from 'react';

import { TableCell, TableHeader, TableRow, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { WIZARD_TABLE_COLUMN_WIDTH } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/WizardVacanciesTable/WizardVacanciesTableBody/WizardVacanciesTableBody';

import { selectWizardVacancies } from 'store/models/campaignCreationWizard';
import { useSelector } from 'store/utils';

const TrlKeys = {
    vacancies: 'CampaignCreationWizard.VacancySelectStep.table.header.vacancies',
    region: 'CampaignCreationWizard.VacancySelectStep.table.header.region',
    manager: 'CampaignCreationWizard.VacancySelectStep.table.header.manager',
};

export const WizardVacanciesTableHeader: FC = () => {
    const trl = useTrls();
    const vacancies = useSelector(selectWizardVacancies);

    return (
        <TableHeader data-qa="wizard-vacancies-table-header">
            <TableRow align="left">
                <TableCell Element="th" data-qa="wizard-table-header-vacancies">
                    <Text style="secondary" typography="label-2-regular">
                        {trl(TrlKeys.vacancies, [vacancies.length])}
                    </Text>
                </TableCell>
                <TableCell Element="th" width={WIZARD_TABLE_COLUMN_WIDTH.area} data-qa="wizard-table-header-region">
                    <Text style="secondary" typography="label-2-regular">
                        {trl(TrlKeys.region)}
                    </Text>
                </TableCell>
                <TableCell Element="th" width={WIZARD_TABLE_COLUMN_WIDTH.manager} data-qa="wizard-table-header-manager">
                    <Text style="secondary" typography="label-2-regular">
                        {trl(TrlKeys.manager)}
                    </Text>
                </TableCell>
            </TableRow>
        </TableHeader>
    );
};
